import Pledge from '~/classes/Pledge'

export default class Loader<T> {
  private readonly _id: string
  private _pledge: Pledge<T>

  get id () {
    return this._id
  }

  constructor (id: string, pledge: Pledge<T>) {
    this._id = id
    this._pledge = pledge
  }

  public async go (): Promise<T | undefined> {
    return await this._pledge.go()
  }
}
